import styled from 'styled-components';

export const LabelText = styled.p`
  font-weight: bold;
  padding-top: 4px;
  padding-right: 24px;
  text-align: right;
  width: 100%;
`;

export const ValueText = styled.p`
  padding-top: 4px;
  width: 100%;
`;

export const SuccessText = styled.p`
  font-weight: bold;
  margin-bottom: 25px;
  width: 447px;
`;

type ErrorTextProps = {
  fontWeight?: string;
  mb?: number;
};

export const ErrorText = styled.p<ErrorTextProps>`
  color: ${({ theme }) => theme.red};
  font-weight: ${({ fontWeight }) => fontWeight ?? 'normal'};
  margin-bottom: ${({ mb }) => mb ?? '25'}px;
  width: 447px;
`;

export const RequiredIndicator = styled.span`
  color: ${({ theme }) => theme.red};
  font-family: SimSun, sans-serif;
  font-size: 14px;
  font-weight: normal;
`;
